module.exports = __webpack_public_path__ + "96e2826380f8ca7de7de419863061ae3.png";